import { useCallback, useRef } from 'react';

export const useCallbackOnce = <
  T extends (...args: Parameters<T>) => ReturnType<T>,
>(
  callback: T,
): ((...args: Parameters<T>) => ReturnType<T> | undefined) => {
  const called = useRef(false);

  return useCallback(
    (...args: Parameters<T>): ReturnType<T> | undefined => {
      if (!called.current) {
        called.current = true;
        return callback(...args);
      }
    },
    [callback],
  );
};
